// Static "related places" menus for the global search palette: given a driver
// login or a vehicle rego, the places in the engine you'd want to jump to with
// that identifier pre-filled. Deep links follow the app's query-param
// convention — each target page seeds its own filter state from the param.
// adminOnly rows are stripped for non-admins by the palette (same rule as the
// sidebar's visibleNavItems).
import {
  Users, ClipboardCheck, Zap, PackageSearch, Activity, ShieldCheck, FileSignature,
  Headphones, Flag, Ban, BookUser, CalendarDays, Truck, Wrench, Gavel, ShieldAlert, Car,
} from 'lucide-react';

export function driverPlaces(login) {
  const L = encodeURIComponent(String(login || '').toUpperCase());
  return [
    { label: 'Personnel record',       href: `/personnel?q=${L}`,                      icon: Users },
    { label: 'Shift Approvals',        href: `/shift-approvals?driver=${L}`,           icon: ClipboardCheck },
    { label: 'RCTI & Xero',            href: `/rcti?driver=${L}`,                      icon: Zap },
    { label: 'Parcel Audit',           href: `/parcel-audit?driver=${L}`,              icon: PackageSearch },
    { label: 'Driver Activity Summary', href: '/driver-activity-summary',              icon: Activity },
    { label: 'Compliance docs',        href: `/compliance?driver=${L}`,                icon: ShieldCheck, adminOnly: true },
    { label: 'Contracts',              href: `/contracts?tab=subcontractor&driver=${L}`, icon: FileSignature },
    { label: 'Customer Cases',         href: `/customer-cases?q=${L}`,                 icon: Headphones, adminOnly: true },
    { label: 'Issue Register',         href: `/driver-issues?q=${L}`,                  icon: Flag, adminOnly: true },
    { label: 'Mail Stoppers',          href: `/mail-stoppers?q=${L}`,                  icon: Ban, adminOnly: true },
    { label: 'Driver login & PIN',     href: `/drivers?q=${L}`,                        icon: BookUser },
    { label: 'Leave Calendar',         href: '/roster',                                icon: CalendarDays },
  ];
}

export function vehiclePlaces(rego) {
  const R = encodeURIComponent(String(rego || '').toUpperCase());
  return [
    { label: 'Fleet record',                 href: `/fleet?rego=${R}`,           icon: Truck },
    { label: 'Service & Repairs',            href: `/vehicle-service?rego=${R}`, icon: Wrench },
    { label: 'Fines & Infringements',        href: `/traffic-fines?rego=${R}`,   icon: Gavel, adminOnly: true },
    { label: 'Accident / Insurance Claims',  href: '/vehicle-claims',            icon: ShieldAlert, adminOnly: true },
    { label: 'Driver Accidents',             href: '/driver-accidents',          icon: Car, adminOnly: true },
  ];
}
